import { UAParser } from "ua-parser-js";

export type UserAgentResult = UAParser.IResult & { isCrawler: boolean };

const extraCrawlerUserAgents: UAParser.RegexMap = [
    [/(facebookexternalhit)\/([\w.]+)/i], [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION, [UAParser.BROWSER.TYPE, 'crawler']],
];
export const parseUserAgent = (userAgent: string): UserAgentResult => {
    const parser = new UAParser({ browser: extraCrawlerUserAgents });
    parser.setUA(userAgent);
    return {
        ...parser.getResult(),
        isCrawler: parser.getBrowser().type === "crawler",
    };
}
